import { createApiClient } from '@crave/api-client';
import { getAccessToken, refreshAccessToken } from './lib/auth.ts';

export const apiBaseUrl =
  (import.meta.env['VITE_API_URL'] as string | undefined) ?? 'http://localhost:8787';
export const api = createApiClient({
  baseUrl: `${apiBaseUrl}/v1`,
  getToken: getAccessToken,
  onUnauthorized: refreshAccessToken,
});
export const siteUrl =
  (import.meta.env['VITE_SITE_URL'] as string | undefined) ?? 'https://cravepizzafl.com';
